import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL, envConfig } from "../config";

export interface Setting<T = any> {
  key: string;
  value: T;
}

export const settingsApi = createApi({
  reducerPath: "settingsApi",
  baseQuery: fetchBaseQuery({
    credentials: "include",
    baseUrl: BASE_URL + "settings",
    prepareHeaders: (headers) => {
      headers.set("api-key", `${envConfig.API_KEY}`);
      return headers;
    },
  }),
  tagTypes: ["Settings"],
  endpoints: (builder) => ({
    getSetting: builder.query<Setting, string>({
      query: (key) => `/${key}`,
      providesTags: (_result, _err, key) => [{ type: "Settings", id: key }],
    }),
    upsertSetting: builder.mutation<Setting, { key: string; value: any }>({
      query: ({ key, value }) => ({
        url: `/${key}`,
        method: "PATCH",
        body: { value },
      }),
      invalidatesTags: (_result, _err, { key }) => [{ type: "Settings", id: key }],
    }),
  }),
});

export const { useGetSettingQuery, useUpsertSettingMutation } = settingsApi;
